export const WHATSAPP_PHONE = '5511918999148'

export const ARGOS_WHATSAPP_REDIRECT_URL =
  'https://seus-direitos-api.apps.jusbr.com/whatsapp/redirect'

export interface BuildWhatsappRedirectParams {
  message: string
  deviceId?: string
  userId?: string
}

export function buildWhatsappRedirect({
  message,
  deviceId,
  userId,
}: BuildWhatsappRedirectParams): string {
  const params = new URLSearchParams({
    phone: WHATSAPP_PHONE,
    message,
  })
  if (deviceId) params.set('device_id', deviceId)
  if (userId) params.set('user_id', userId)
  return `${ARGOS_WHATSAPP_REDIRECT_URL}?${params.toString()}`
}
